import { Component } from '@angular/core';
import { RevealDirective } from '../../core/directives/reveal.directive';

@Component({
  selector: 'hx-promo-banner',
  standalone: true,
  imports: [RevealDirective],
  template: `
    <section class="section-tight">
      <div class="wrap">
        <div class="promo-banner reveal" appReveal>
          <div>
            <span class="promo-banner-tag">Limited · New Clients</span>
            <h2>Free infrastructure audit with any new build.</h2>
            <p>
              Sign a new project this quarter and we'll review your current cloud setup at no cost —
              architecture, cost, and security, in one report.
            </p>
          </div>
          <a href="#referral-form" class="btn btn-primary">Claim this offer</a>
        </div>
      </div>
    </section>
  `,
})
export class PromoBannerComponent {}
